export default [{
  path: '/attendance_report',
  name: 'attendance_report',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/AttendanceReport/index')
}]

